import get from 'lodash/get';
import has from 'lodash/has';

declare global {
  interface Window {
    /**
     * Default location to receive app state generated by the server on load
     *
     * To use another location as the source of app state, you can use the
     * Webpack Define plugin to overwrite the expression
     * `window._RELIV_APP_STATE` with a different expression.
     *
     * @see https://webpack.js.org/plugins/define-plugin/
     */
    _RELIV_APP_STATE: Readonly<{ [key: string]: unknown }>;
  }
}

/**
 * Return app state for a given key, optionally returning a default value.
 *
 * @param path Name or path to state property. (May be dotted, ie. "a.b.c")
 * @param default_ Value to return if the key is not set.
 * @return Value at the given key
 */
export default function getAppState<T = unknown>(path: string, def?: Readonly<T>): Readonly<T> {
  if (!has(window._RELIV_APP_STATE, path) && typeof def === 'undefined') {
    // tslint:disable-next-line:no-console
    console.warn(`State path "${path}" not defined and no default given`);
    return;
  }
  return get(window._RELIV_APP_STATE, path, def) as T;
}
